// COAR-52746: host-provided flag indicating a title (POATA) step follows the
// contract. The contract MFE is mounted separately from the eTitle step and has
// no visibility into the MFE order, so the host sets this on the contract mount
// to tell us the automated funding thinker should run after the POATA instead.
let titleFollows = false;

export const getTitleFollows = () => titleFollows;

export const setTitleFollows = value => {
  titleFollows = value;
};
